import {useMessages} from "i18n";
import Seo from "../seo/Seo";
import {ContentSurface, Prose} from "../components/ContentPage";
import Impressum from "../legal/Impressum";

/**
 * Public, pre-rendered provider-identification page (kitecorp/transferify-ui#2291).
 *
 * It is the German market's mandatory Impressum (§ 5 DDG, the former TMG § 5, together with § 18
 * Abs. 1 MStV), which is why it is a pre-rendered ROUTE rather than another body in the Resources
 * dialog: the information has to be easily recognisable, directly accessible and permanently
 * available, and only a real URL is all three. Abs. 1 and not Abs. 2: the German pages are
 * commercial self-presentation rather than a journalistisch-redaktionell gestaltetes Angebot, so no
 * Verantwortlicher is owed and the page names none (kitecorp/transferify-ui#2590). The English and Romanian trees serve the same page
 * because the route mirrors must declare identical paths and the company being identified is the
 * same one on every brand.
 */
export function Component() {
	const {resourceTitles, seo} = useMessages();
	return (
		<>
			<Seo
				title={seo.impressum.title}
				description={seo.impressum.description}
				path="/impressum"
			/>
			<ContentSurface>
				<Prose>
					<h1>{resourceTitles.impressum}</h1>
					<Impressum/>
				</Prose>
			</ContentSurface>
		</>
	);
}
